(() => {
  const componentSelector = 'm-product-tabs[data-lazy-tabs="true"]';

  const getTabFromHeader = (component, header) => {
    const targetId = header.getAttribute('href');
    return targetId ? component.querySelector(targetId) : null;
  };

  const initialiseLoadedTab = (component, tab) => {
    if (component.sliderEnabled && typeof component.initSliderByScreenSize === 'function') {
      component.initSliderByScreenSize(tab);
    }

    if (component.buttonType === 'load' && typeof component.initLoadMore === 'function') {
      component.initLoadMore(tab);
    }
  };

  const hydrateTabs = async (component, requestedTab) => {
    if (!requestedTab || !requestedTab.hasAttribute('data-lazy-tab')) return;
    if (component.dataset.lazyState === 'loading' || component.dataset.lazyState === 'loaded') return;

    const url = requestedTab.dataset.lazyUrl;
    if (!url) return;

    component.dataset.lazyState = 'loading';
    component.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error(`Unable to load product tabs (${response.status})`);

      const html = await response.text();
      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      const sourceComponent = parsedDocument.getElementById(component.id);
      if (!sourceComponent) throw new Error('Product tab section was not returned');

      component.querySelectorAll('[data-lazy-tab]').forEach((targetTab) => {
        const sourceTab = sourceComponent.querySelector(`#${CSS.escape(targetTab.id)}`);
        if (!sourceTab || !sourceTab.querySelector('[data-products-container]')) return;

        const oldSlider = targetTab.querySelector('.m-mixed-layout__wrapper');
        if (oldSlider && oldSlider.swiper) oldSlider.swiper.destroy(true, true);

        targetTab.innerHTML = sourceTab.innerHTML;
        targetTab.removeAttribute('data-lazy-tab');
        targetTab.removeAttribute('data-lazy-url');
        initialiseLoadedTab(component, targetTab);
      });

      component.dataset.lazyState = 'loaded';
      component.dispatchEvent(new CustomEvent('product-tabs:loaded'));
    } catch (error) {
      component.dataset.lazyState = 'error';
      requestedTab.innerHTML = `<p class="m:text-center"><a href="${url.split('?')[0]}">View this collection</a></p>`;
      console.warn(error);
    } finally {
      component.removeAttribute('aria-busy');
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const header = event.target.closest(`${componentSelector} .m-tab-header`);
      if (!header) return;
      const component = header.closest(componentSelector);
      hydrateTabs(component, getTabFromHeader(component, header));
    },
    true
  );

  document.addEventListener('change', (event) => {
    const select = event.target.closest(`${componentSelector} [data-tab-select]`);
    if (!select) return;
    const component = select.closest(componentSelector);
    const tab = component.querySelector(`.m-tab-content[data-index="${select.value}"]`);
    hydrateTabs(component, tab);
  });
})();
